module.exports = __webpack_public_path__ + "static/media/icon-commerce.4d14fb46.svg";